import React, { useState, useContext } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { ToastContext } from '../../contextStore/ToastContext';
import './InfoPages.css';

function ContactUs() {
  const { addToast } = useContext(ToastContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder: in production would send to backend or email service
    addToast('Thank you for reaching out to ClubLoop. Our team will get back to you soon.', 'success');
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>Contact ClubLoop Support</h1>
          <p>
            Have a question about club grading, a pending payout, or need help with a listing?
            We are here to help keep golf moving.
          </p>
        </div>

        <div className="infoSection">
          <h2>Send us a message</h2>
          <form className="infoForm" onSubmit={handleSubmit}>
            <label htmlFor="contact-name">Name</label>
            <input
              id="contact-name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your name"
            />

            <label htmlFor="contact-email">Email</label>
            <input
              id="contact-email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="your@email.com"
            />

            <label htmlFor="contact-subject">Subject</label>
            <select
              id="contact-subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            >
              <option value="">Select a subject</option>
              <option value="grading">Club Grading & Verification Assistance</option>
              <option value="p2p-escrow">P2P Escrow & Payment Protections</option>
              <option value="listings">Active Listings & Photo Upload Support</option>
              <option value="business">Pro Shop & Golf Course Partnerships</option>
              <option value="other">Other Queries</option>
            </select>

            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Tell us about the equipment or transaction you need help with..."
            />

            <button type="submit" className="infoBtn">
              Send message
            </button>
          </form>
        </div>

        <div className="infoSection">
          <h2>Other ways to reach us</h2>
          <p>
            <strong>Instant Assistance:</strong> For urgent order confirmations or live transaction protection issues,
            connect directly via our automated WhatsApp Business channel[cite: 48, 154].
          </p>
          <p>
            <strong>Escrow & Payout Queries:</strong> P2P Marketplace payments are held securely[cite: 30, 32].
            If you need to raise a dispute regarding a delivered club, please select "P2P Escrow" in the form above
            within 5 days of delivery to safely freeze the payout[cite: 97, 121].
          </p>
          <p>
            <strong>Community & Socials:</strong> Catch up with team alerts, trade tips, and club marketplace
            launches through our active local golf community networks[cite: 154].
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactUs;
